import React from 'react'
import { Label } from 'atoms/Texts'
import { BadgeItem } from './styles'
import { withTheme } from 'styled-components'

const UnreadBadge = ({ count, theme }) => {
  return (
    <BadgeItem>
      <Label mb={'0'} lineheight={'11px'} size={'9px'} weight={'600'} color={theme.white}>
        {count}
      </Label>
    </BadgeItem>
  )
}

export default withTheme(UnreadBadge)
